import { isElementNearViewport } from "./isElementNearViewport";

/**
 * Check if an element is in the viewport. If the element is not within the viewport, or
 * the element is null, return false.
 * @param element HTMLElement | null
 * @returns true if the element is within the current viewport, false otherwise
 */
export function isElementInViewport(element: HTMLElement | null): boolean {
  // Call isElementNearViewport with a margin of 0 to check if the element is in the viewport
  return isElementNearViewport(element, 0);
}
